import { dividerClassName, pxArrayToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const FilterSectionWrapper: StyleRule = ({ theme }) => ({
    [`& .${dividerClassName}`]: {
        padding: pxArrayToRem([0, 0, 24, 0]),
        '::before': {
            backgroundColor:
                theme.siteVariables.colorScheme.default?.foreground,
        },
    },
});
